import styled from "styled-components";

export const MainArticle = styled.article`
  width: 100%;
  //min-width: 400px;
  //height: 600px;
  //padding: 0px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  order: 0;
  margin-bottom: 50px;
  @media (min-width: 885px) {
    width: 48%;
  }
  /* @media (max-width: 450px) {
    min-width: 300px;
  } */
  /* @media (max-width: 670px) {
    width: 90%;
  } */
  /* @media (max-width: 580px) {
    height: 650px;
  }
  @media (max-width: 540px) {
    height: 670px;
  }
  */
`;
